import { render, staticRenderFns } from "./RecordedDetailKodiButton.vue?vue&type=template&id=39a76b84&"
import script from "./RecordedDetailKodiButton.vue?vue&type=script&lang=ts&"
export * from "./RecordedDetailKodiButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports